/*
 * @Author: Merlin
 * @Date: 2024-11-11 13:10:30
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-08 11:01:08
 * @Description: 
 */
import {
    oTable4Types,
} from '@/pages/casino/futuresGame/ts/wavesData'; 

export enum HistoryTabsEnum{
    All = 'all',
    History = 'history',
    MyBets = 'myBets',
    High = 'high',
    Rare = 'rare',
    BetsOnline = 'betsOnline',
    // ↓ 以下是 waves 游戏专用 ---------- 
    active = oTable4Types.active,
    closed = oTable4Types.closed,
    public = oTable4Types.public,
    leaderboard = oTable4Types.leaderboard,
};

// ↓ 游戏下的表格分页的选项 
export const aPagination = [
    { name: '10', value: '10' },
    { name: '20', value: '20' },
    { name: '30', value: '30' },
    { name: '40', value: '40' },
    { name: '50', value: '50' },
];

// 表格行数的上限 
export const iPaginationMax = Math.max(
    ...aPagination.map(cur => Number(cur.value))
);
